import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';
import {constants} from '../../utils/constants';
import {callTealiumLink} from '../../utils/helpers';


export class Postal extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();

    window.open(constants.postalHref, '_blank');
    callTealiumLink({event_name: 'linkClick', link_category: 'exit', 'link_name': 'Postal' });
  }

  render() {
    return (
      <div className='linkOutContainer'>
        <h2 className='linkOutTitle'>{this.translate('postalTitle')}</h2>
        <p className='linkOutDescription'>{this.translate('postalOptoutSubhead')}</p>
        <button id='postalButton' onClick={this.handleClick} className='linkOutButton'>{this.translate('postalTitle')}</button>
      </div>
    );
  }
}

TranslatedComponent(Postal);
export default Postal;



// WEBPACK FOOTER //
// ./client/src/components/linkOuts/Postal.jsx